import { createSlice } from "@reduxjs/toolkit";
import { AddChat, AddMessage, GetChatsList, GetMessagesList } from "./chatActions";

const initialState: any = {
  chats: [],
  messages:[],
  loading: false,
  showChatAddModal: false,
  title: "Add",
  pagination: {},
  totalRecords: 0,
  selectedChat: {},
  conformationChatModal: false,
  showChatDetailModal: false,
};

const chatSlice = createSlice({
  name: "chatSlice",
  initialState,
  reducers: {
    setShowChatAddModal: (state) => {
      state.showAidAddModal = true;
    },
    setCloseChatAddModal: (state) => {
      state.showAidAddModal = false;
    },
    setSelectedChat: (state, { payload }) => {
      state.selectedChat = payload;
    },

    setChatTitle: (state, { payload }) => {
      state.title = payload;
    },

    setshowConfirmationChatModal: (state) => {
      state.conformationChatModal = true;
    },

    setCloseConfirmationChatModal: (state) => {
      state.conformationChatModal = false;
    },

    setOpenChatDetailModal: (state) => {
      state.showChatDetailModal = true;
    },
    setCloseChatDetailModal: (state) => {
      state.showChatDetailModal = false;
    },
  },
});

const addChat = createSlice({
  name: "addChat",
  initialState,
  reducers: {},
  extraReducers: (builder: any) => {
    builder
      .addCase(AddChat.pending, (state: any) => {
        state.loading = true;
      })
      .addCase(AddChat.fulfilled, (state: any, { payload }) => {
        state.loading = false;
        state.chats = payload.data;
      })
      .addCase(AddChat.rejected, (state: any, action: any) => {
        state.error = action.payload.error;
        state.loading = false;
      });
  },
});


const addMessage = createSlice({
  name: "addMessage",
  initialState,
  reducers: {},
  extraReducers: (builder: any) => {
    builder
      .addCase(AddMessage.pending, (state: any) => {
        state.loading = true;
      })
      .addCase(AddMessage.fulfilled, (state: any, { payload }) => {
        state.loading = false;
        state.messages = payload.data;
      })
      .addCase(AddMessage.rejected, (state: any, action: any) => {
        state.error = action.payload.error;
        state.loading = false;
      });
  },
});

const getChatsList = createSlice({
  name: "getChatsList",
  initialState,
  reducers: {
    addChat: (state, { payload }) => {
      state.chats = [...state.chats, payload];
    },
  },
  extraReducers: (builder: any) => {
    builder
      .addCase(GetChatsList.pending, (state: any) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(GetChatsList.fulfilled, (state: any, { payload }) => {
        state.loading = false;
        state.chats = payload.data;
        state.pagination = payload.pagination;
      })
      .addCase(GetChatsList.rejected, (state: any, action: any) => {
        state.loading = false;
      });
  },
});

const getMessagesList = createSlice({
  name: "getMessagesList",
  initialState,
  reducers: {
    addMessage: (state, { payload }) => {
      state.messages = [...state.messages, payload];
    },
  },
  extraReducers: (builder: any) => {
    builder
      .addCase(GetMessagesList.pending, (state: any) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(GetMessagesList.fulfilled, (state: any, { payload }) => {
        state.loading = false;
        state.messages = payload.data?.messages;
        state.selectedChat= payload.data?.room;
        state.pagination = payload.pagination;
      })
      .addCase(GetMessagesList.rejected, (state: any, action: any) => {
        state.loading = false;
      });
  },
});
export const chatCommonReducer = chatSlice.reducer;
export const addChatReducer = addChat.reducer;
export const addMessageReducer = addMessage.reducer;
export const getChatsListReducer = getChatsList.reducer;
export const getMessagesListReducer = getMessagesList.reducer;
export const {
  setShowChatAddModal,
  setCloseChatAddModal,
  setChatTitle,
  setSelectedChat,
  setCloseConfirmationChatModal,
  setshowConfirmationChatModal,
  setOpenChatDetailModal,
  setCloseChatDetailModal,
} = chatSlice.actions;
